<script lang="ts" setup>
import ProjectBadge from "~/components/project/ProjectBadge.vue";
import type {ProjectMeta} from "~/types/Project/ProjectMeta.interface";

const {item} = defineProps<{
    item: {
        slug: string,
        title: string
        hat: string,
        category: string,
        meta: ProjectMeta
    }
}>();
const {data: images} = await useFetch('/api/getAssetImages', {
    query: {
        slug: item.slug,
        limit: 1,
    },
    default: () => []
});
</script>

<template>
  <article class="bg-white p-4 rounded-img">
    <picture v-if="images.length" class="mb-6 rounded-img overflow-hidden block">
      <media-source
              :dimensions="[
                        { width: 1920 },
                        { width: 1280 },
                        { width: 640 }
                      ]"
              :uri="images[0] as string"
              as="source"
              format="webp"
              sizes="100vw, (min-width: 768px) 25vw"
      />
      <media-source
              :alt="item.title"
              :dimensions="[
                        { width: 1920 },
                        { width: 1280 },
                        { width: 640 }
                      ]"
              :uri="images[0] as string"
              as="img"
              class-name="w-full h-full object-cover rounded-img aspect-16/12"
              format="jpg"
              sizes="100vw, (min-width: 768px) 25vw"
      />
    </picture>
    <header class="mb-4 px-4">
      <span class="text-brand-dark text-xs uppercase block mb-4 font-medium">{{ item.category }}</span>
      <h3 class="text-lg text-secondary font-medium line-clamp-2">
        {{ item.title }}
      </h3>
    </header>
    <p class="text-grey line-clamp-3 text-sm mb-6 px-4">
      {{ item.hat }}
    </p>
    <ProjectBadge
            :item-meta="item.meta as ProjectMeta"
            class="flex flex-wrap gap-2 px-4 mb-8"
    />
  </article>
</template>

<style scoped>

</style>